import * as React from 'react';
export const LazyUncontrolledRecipientWell = React.lazy(() =>
    import(/* webpackChunkName: "UncontrolledRecipientWell" */ 'owa-readwrite-recipient-well-fabric/lib/components/UncontrolledRecipientWell')
);
